var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('page-header',{attrs:{"title":"Reward History","pre-title":"Overview","loading":false}}),_c('page-route-view',{attrs:{"loading":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }